module.exports = __webpack_public_path__ + "img/louis.0bbafd0c.png";